var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('th',_vm._g(_vm._b({class:_setup.head(_setup.rootProps),attrs:{"data-component":"CsTableHead"}},'th',_setup.attrs,false),_setup.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }